import * as React from 'react';
import { useNavigate } from 'react-router-dom';

// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies,ordered-imports/ordered-imports
import { Howl } from 'howler';

import { useData, useSleepMode } from '../../hooks';
import { IDetail, IScore } from '../../types';

import './animation.css';
import { StyledFloatingArea } from './styled';
import { animation } from './helpers';

const FloatingIdeas = () => {
  const { setStartTime } = useSleepMode();
  const navigate = useNavigate();
  const { scores = [], details = [] } = useData();
  React.useEffect(() => setStartTime(Date.now()), []);
  const ref = React.createRef<HTMLDivElement>();

  const [sound, setSound] = React.useState<any>();
  React.useEffect(() => {
    const soundObject = new Howl({
      src: ['./audios/interaction-sounds/overview-1-background-loop.mp3'],
      loop: true,
      volume: 0.05,
      onload: () => {
        setSound(soundObject);
      },
    });
  }, []);

  React.useEffect(() => {
    if (sound) {
      sound.play();
      sound.fade(0, 0.05, 1000);
    }

    return () => {
      if (sound) {
        sound.fade(0.05, 0, 1000);
      }
    };
  }, [sound]);

  const onClickScoreButton = (item: IScore) => {
    navigate(`/score/${item.id}`);
  };
  const onClickAboutButton = (item: IDetail) => {
    navigate(`/about/${item.id}`);
  };

  React.useEffect(() => {
    if (scores.length > 0) {
      animation(scores, 12, onClickScoreButton, 5, 'score-title');
    }
  }, [scores.length]);

  React.useEffect(() => {
    if (details.length > 0) {
      animation(details, 3, onClickAboutButton, 1, 'title');
    }
  }, [details.length]);

  return <StyledFloatingArea ref={ref} id="floating-area" />;
};

export default FloatingIdeas;
